import conf from 'conf/conf';
import { _localGet, _localSet } from 'utils/helpers/gimHelper';

/** Коди мов платформи з conf (REACT_APP_LANGS). */
export const getAppLangCodes = (): string[] => {
    const codes = Array.isArray(conf.langs) ? conf.langs : [];
    return codes.length ? codes : [conf.defaultLang || 'ua'];
};

/** @deprecated alias — використовуйте getAppLangCodes */
export const getAppLangs = getAppLangCodes;

export const getDefaultLangCode = (codes: string[] = getAppLangCodes()): string => {
    const def = String(conf.defaultLang || 'ua').trim().toLowerCase() || 'ua';
    if (codes.includes(def)) return def;
    return codes[0] || 'ua';
};

/** Початкова мова: збережена користувачем (якщо доступна) або default з conf. */
export const getInitialLangCode = (): string => {
    const codes = getAppLangCodes();
    const stored = _localGet(conf.langStorageKey);
    if (stored && codes.includes(stored)) return stored;
    return getDefaultLangCode(codes);
};

export const canSwitchAppLang = (codes: string[] = getAppLangCodes()): boolean => codes.length > 1;

export const setStoredLang = (code: string): void => {
    _localSet(conf.langStorageKey, code);
};
